import React from 'react'
import "../components/css/skill.css"
const Skill = () => {
  return (
    <div className='skill-container'>
      <div className="skill-image"> <img src="./images/skill.jpg" alt="" /></div>
      <div className="skills">

  
        <div className="skill-item">HTML : <div className="skillline-1"> </div> </div>
        <div className="skill-item">CSS : <div className="skillline-2"> </div> </div>
        <div className="skill-item">REACT.JS : <div className="skillline-3"> </div> </div>
        <div className="skill-item">JAVASCRIPTS : <div className="skillline-4"> </div> </div>
        <div className="skill-item">NODE.JS : <div className="skillline-5"> </div> </div>
        <div className="skill-item">EXPRESS : <div className="skillline-6"> </div> </div>
        <div className="skill-item">POSTMAN : <div className="skillline-7"> </div> </div>
        <div className="skill-item">MONGODB : <div className="skillline-8"> </div> </div>
        <div className="skill-item">PYTHON : <div className="skillline-9"> </div> </div>
        <div className="skill-item">PHP : <div className="skillline-10"> </div> </div>
        <div className="skill-item">BOOTSTRAP : <div className="skillline-11"> </div> </div>
      </div>
      
    </div>
    
  )
}

export default Skill
